var d3 = Object.assign({}, require("d3-fetch"), require("d3-selection"), require("d3-array"), require("d3-format"), require("d3-time-format"), require("d3-format"), require("d3-scale"), require("d3-scale-chromatic"));
import '../scss/main.scss';
import greeting from './greeting.ejs';
var isEmbedded = window.location !== window.parent.location;

var debounce = require('debounce');

import makeScrolly from "./makeScrolly"; // We're in an iframe

if (isEmbedded) {
  window.childFrame.sendHeight();
}

var theScrolls = [];

function init() {
  var cache = new Date().getTime();
  main();
}

function main() {
  if (!isEmbedded) {
    loadScrolly();
  } else {
    d3.selectAll("body").classed("is-embedded", true);
  }

  d3.selectAll("body").classed("loaded", true);
}

function loadScrolly() {
  var scrollySection = new makeScrolly({
    element: "#scrolly",
    onStepChange: function onStepChange(val) {
      var index = val.index + 1;
      d3.selectAll("#scrolly .figure-holder").classed('active', false).classed('inactive', true);
      d3.select("#scrolly .figure-holder.figure-".concat(index)).classed('active', true).classed('inactive', false);
    }
  }); //theScrolls.push(scrollySection);
}

init();